import React,{useEffect,useState} from "react";
import { useParams } from "react-router-dom";
import { Grid } from "@mui/material";
import { useSelector, useDispatch } from "react-redux";
import { Form } from "react-final-form";
import * as yup from "yup";
import Button from "@mui/material/Button";
import Stack from "@mui/material/Stack";
import ControlPointIcon from "@mui/icons-material/ControlPoint";
import RemoveCircleOutlineIcon from "@mui/icons-material/RemoveCircleOutline";
import FormControlLabel from "@mui/material/FormControlLabel";
import { UiInputGroupWr } from "../../../../../../_uiComponents/common/form/UiInputComponents";
import UiInput from "../../../../../../_uiComponents/UiInput";
import UiSwitch from "../../../../../../_uiComponents/common/form/UiSwitch";
import UiCropFileUpload from "../../../../../../_uiComponents/common/form/UiCropFileUpload";
import {
     UiButton,
     UiBackButton,
     UiIconButton,
} from "../../../../../../_uiComponents/common/form/UiButton";
import Validator from "../../../../../../../_helpers/validate.schema";
import PublishedTable from "../PublishedTable";
import { incentiveQuickContentAddRequest, incentiveQuickPublishedRevisionRequest } from "../../../../../../../_redux/_actions";

const validateSchema = () =>
     yup.object().shape({
          menuTitle: yup.string().max(50, 'tile characters are more than 50'),
          title:yup.string().max(50, 'tile characters are more than 50'),
          description:yup.string().max(50, 'tile characters are more than 50'),

          stepOneTitle: yup.string().max(50, 'tile characters are more than 50'),
          stepTwoTitle: yup.string().max(50, 'tile characters are more than 50'),
          stepThreeTitle: yup.string().max(50, 'tile characters are more than 50'),

          stepOneDesc: yup.string().max(2500, 'tile characters are more than 2500'),
          stepTwoDesc: yup.string().max(2500, 'tile characters are more than 2500'),
          stepThreeDesc: yup.string().max(2500, 'tile characters are more than 2500'),

     });

const onValidate = async (values) => {
     return await Validator(values, validateSchema);
};

export default function QuickReadCOntentForm(props) {

     const { id } = useParams();
     const actionDispatch = useDispatch();

     const [initialValuesList,setInitialValuesList] = useState({});

     useEffect(()=>{

          actionDispatch(
               incentiveQuickPublishedRevisionRequest({
                    campaignId:props.campaignId
               }),
          );

     },[]);

     const { contentQuickDetails,publishedData } = useSelector(
          (state) => {
               return {
                    publishedData:state.incentive.contentQuickRevisionPublished,
                    contentQuickDetails:state.incentive.contentQuickDetails,
               };
          },
     );


     useEffect(()=>{

          let tempObj = {};

          if(contentQuickDetails?.MenuTitle){

               tempObj.menuTitle = contentQuickDetails.MenuTitle;
               tempObj.title = contentQuickDetails.Title;
               tempObj.description = contentQuickDetails.Description;


               if(contentQuickDetails?.IncentiveCampaignContentQuickReadSectionDtos[0]){

                    let sectionOneObj = contentQuickDetails?.IncentiveCampaignContentQuickReadSectionDtos[0];
                    
                    tempObj.stepOneTitle = sectionOneObj.title;
                    tempObj.stepOneDesc = sectionOneObj.description;
                    
               }

               if(contentQuickDetails?.IncentiveCampaignContentQuickReadSectionDtos[1]){

                    let sectionTwoObj = contentQuickDetails?.IncentiveCampaignContentQuickReadSectionDtos[1];
                    
                    tempObj.stepTwoTitle = sectionTwoObj.title;
                    tempObj.stepTwoDesc = sectionTwoObj.description;
                    
               }

               if(contentQuickDetails?.IncentiveCampaignContentQuickReadSectionDtos[2]){

                    let sectionThreeObj = contentQuickDetails?.IncentiveCampaignContentQuickReadSectionDtos[2];
                    
                    tempObj.stepThreeTitle = sectionThreeObj.title;
                    tempObj.stepThreeDesc = sectionThreeObj.description;
                    
               }

               console.log(tempObj);

               setInitialValuesList(tempObj);

          }

     },[contentQuickDetails]);

     const submit = async (values,form) => { 

          let finalPayload = {
               id: id,
               menuTitle: values.menuTitle,
               title:values.title,
               description:values.description,
               incentiveCampaignContentQuickReadSectionDtos: [],
               changeReason: values.changeReason ? values.changeReason : "",
               page: 1,
               pageSize: 5,
               form
          };

          if (values?.stepOneTitle) {

               let payload = {
                    "Index": 1,
                    "title": values.stepOneTitle,
                    "description": values.stepOneDesc,
               };

               finalPayload.incentiveCampaignContentQuickReadSectionDtos.push(payload);

          }

          if (values?.stepTwoTitle) {

               let payload = {
                    "Index": 2,
                    "title": values.stepTwoTitle,
                    "description": values.stepTwoDesc,
               };

               finalPayload.incentiveCampaignContentQuickReadSectionDtos.push(payload);

          }

          if (values?.stepThreeTitle) {

               let payload = {
                    "Index": 3,
                    "title": values.stepThreeTitle,
                    "description": values.stepTwoDesc,
               };

               finalPayload.incentiveCampaignContentQuickReadSectionDtos.push(payload);

          }


          actionDispatch(incentiveQuickContentAddRequest(finalPayload));

          setInitialValuesList({});

     };

     return (
          <>
               <Form
                    initialValues={initialValuesList}
                    onSubmit={submit}
                    validate={onValidate}
                    render={({ form, handleSubmit }) => {
                         return (
                              <form onSubmit={validateSchema}>
                                   <div className="sbm-content-section">
                                        <Grid
                                             container
                                             spacing={2}
                                             sx={{ mb: 1, mt: 1 }}
                                        >
                                             <Grid item xs={12} lg={6}>
                                                  <UiInput
                                                       type="text"
                                                       label="Menu Title"
                                                       name="menuTitle"
                                                  />
                                             </Grid>
                                        </Grid>
                                        <Grid
                                             container
                                             spacing={2}
                                             sx={{ mb: 1 }}
                                        >
                                             <Grid item xs={12} lg={6}>
                                                  <UiInput
                                                       type="text"
                                                       label="Title"
                                                       name="title"
                                                  />
                                             </Grid>
                                        </Grid>
                                        
                                        <Grid container spacing={2}>
                                             <Grid item xs={12} lg={6}>
                                                  <UiInput
                                                       type="text"
                                                       label="Description"
                                                       multiline={true}
                                                       minRows={3}
                                                       maxRows={5}
                                                       name="description"
                                                  />
                                             </Grid>

                                             <Grid item xs={12} lg={12}>
                                                  <Grid container spacing={2}>
                                                       <Grid
                                                            item
                                                            xs={12}
                                                            lg={4}
                                                       >
                                                            <UiInputGroupWr title="Step 01">
                                                                 <Grid
                                                                      container
                                                                      spacing={
                                                                           1
                                                                      }
                                                                 >
                                                                      <Grid
                                                                           item
                                                                           xs={12}
                                                                           lg={12}
                                                                      >
                                                                           <UiInput
                                                                                type="text"
                                                                                label="Title"
                                                                                name="stepOneTitle"
                                                                           />
                                                                      </Grid>
                                                                      <Grid
                                                                           item
                                                                           xs={12}
                                                                           lg={12}
                                                                      >
                                                                           <UiInput
                                                                                type="text"
                                                                                label="Description"
                                                                                multiline={
                                                                                     true
                                                                                }
                                                                                minRows={
                                                                                     3
                                                                                }
                                                                                maxRows={
                                                                                     5
                                                                                }
                                                                                name="stepOneDesc"
                                                                           />
                                                                      </Grid>
                                                                 </Grid>
                                                            </UiInputGroupWr>
                                                       </Grid>
                                                       <Grid
                                                            item
                                                            xs={12}
                                                            lg={4}
                                                       >
                                                            <UiInputGroupWr title="Step 02">
                                                                 <Grid
                                                                      container
                                                                      spacing={
                                                                           1
                                                                      }
                                                                 >
                                                                      <Grid
                                                                           item
                                                                           xs={12}
                                                                           lg={12}
                                                                      >
                                                                           <UiInput
                                                                                type="text"
                                                                                label="Title"
                                                                                name="stepTwoTitle"
                                                                           />
                                                                      </Grid>
                                                                      <Grid
                                                                           item
                                                                           xs={12}
                                                                           lg={12}
                                                                      >
                                                                           <UiInput
                                                                                type="text"
                                                                                label="Description"
                                                                                multiline={
                                                                                     true
                                                                                }
                                                                                minRows={
                                                                                     3
                                                                                }
                                                                                maxRows={
                                                                                     5
                                                                                }
                                                                                name="stepTwoDesc"
                                                                           />
                                                                      </Grid>
                                                                 </Grid>
                                                            </UiInputGroupWr>
                                                       </Grid>
                                                       <Grid
                                                            item
                                                            xs={12}
                                                            lg={4}
                                                       >
                                                            <UiInputGroupWr title="Success">
                                                                 <Grid
                                                                      container
                                                                      spacing={
                                                                           1
                                                                      }
                                                                 >
                                                                      <Grid
                                                                           item
                                                                           xs={12}
                                                                           lg={12}
                                                                      >
                                                                           <UiInput
                                                                                type="text"
                                                                                label="Title"
                                                                                name="stepThreeTitle"
                                                                           />
                                                                      </Grid>
                                                                      <Grid
                                                                           item
                                                                           xs={12}
                                                                           lg={12}
                                                                      >
                                                                           <UiInput
                                                                                type="text"
                                                                                label="Description"
                                                                                multiline={
                                                                                     true
                                                                                }
                                                                                minRows={
                                                                                     3
                                                                                }
                                                                                maxRows={
                                                                                     5
                                                                                }
                                                                                name="stepThreeDesc"
                                                                           />
                                                                      </Grid>
                                                                 </Grid>
                                                            </UiInputGroupWr>
                                                       </Grid>
                                                       <Grid
                                                            item
                                                            xs={12}
                                                            lg={6}
                                                            className='sba-campaign-content-text-bg'
                                                       >
                                                            <UiInput
                                                                 type="text"
                                                                 name="changeReason"
                                                                 multiline={true}
                                                                 minRows={3}
                                                                 maxRows={5}
                                                                 label="Change Reason"
                                                            />


                                                       </Grid>
                                                       <Grid
                                                            item
                                                            xs={12}
                                                            lg={12}
                                                            sx={{ mb: 2 }}
                                                       >
                                                            <Stack
                                                                 spacing={2}
                                                                 direction="row"
                                                                 justifyContent="end"
                                                                 sx={{ width: "100%" }}
                                                            >
                                                                 <UiButton
                                                                      name="Clear"
                                                                      variant="outlined"
                                                                      size="small"
                                                                      onClick={()=>{
                                                                           form.reset();
                                                                           setInitialValuesList({});
                                                                      }}
                                                                 />
                                                                 <UiButton
                                                                      name="Save"
                                                                      variant="contained"
                                                                      size="small"
                                                                      onClick={handleSubmit}
                                                                 />
                                                            </Stack>
                                                       </Grid>
                                                       <Grid
                                                            item
                                                            xs={12}
                                                            lg={12}

                                                       >
                                                            <div className="sba-revison-publish-table">
                                                                 <label class="sba-content-label">Published Revision Content</label>
                                                                 <PublishedTable loadData={props.loadQuickRevisionData} publishedData={publishedData} />
                                                            </div>

                                                       </Grid>
                                                  </Grid>
                                             </Grid>

                                        </Grid>
                                   </div>
                              </form>
                         );
                    }}
               />
          </>
     );
}
